
    <div class="calender">
      <br>
        <app-booking-days   *ngFor="let d of timeSlotDays" [day]="d" [upgradeId]="upgradeId" >
      </app-booking-days>
    </div>

